const Chatbot_zh_cn = {
	"botName": "Intelbot",
	"botSubTag": "线上助手",
	"resetWindow": [
		{
			"title": "重置聊天？",
			"subtitle1": "点击是，将清除您的聊天历史， ",
			"subtitle2": "然后重新开始。",
			"Option1": "是",
			"Option2": "否"
		}
	],
	"closeWindow": [
		{
			"title": "结束聊天？",
			"subtitle1": "点击是，结束聊",
			"subtitle2": "天会话。",
			"Option1": "是",
			"Option2": "返回"
		}
	],
	"disclaimerWindow": [
		{
			"title": "通知和免责声明",
			"subtitle1": "英特尔技术可能需要支持的硬件、软件或服务激活。",
			"subtitle2": "没有任何产品或组件是绝对安全的。",
			"subtitle3": "您的成本和结果可能会有所不同。",
			"subtitle4": "© 英特尔公司。英特尔、英特尔标志和英特尔 Evo 是英特尔公司或其子公司的商标。<br>* 文中涉及的其它名称及商标属于各自所有者资产。",
			"Option1": "返回"
		}
	],
	"botMessageRenderer": [
		{
			"text1": "几秒钟前",
			"text2": "一分钟前",
			"text3": "分钟前",
			"text4": "第二",
			"text5": "前",
			"text6": "一小时前",
			"text7": "几小时前",
			"text8": "",
			"text9": ""
		}
	],
	"agentPlaceholder": "代理人",
	"additionalRecommendation": "查看更多...",
	"inputPlaceholder": "开始在此输入…",
	"timeoutNotification": "超时通知",
	"greetingMessage": "欢迎页",
	"greetingtext":"您好，我是 Intelbot，\n 您的线上助理",
	"closeChatSession": "关闭聊天会话",
	"connectToAgent": "連接到現場代理",
	"agentConnect1":"帮我联系代理",
    "fallbackYes":"是",
    "agentGifText":"连接到代理",
	"fallbackResponseNo": "回退响应否",
	"resumeConversation": "恢复对话",
	"sessionClosed": "会话结束",
	"today": "今天",
	"timeoutMessage": "您已经好久没和我说话了，是否继续？",
	"carouselText":"这些是根据您的偏好推荐的合适商品。希望我推荐对了！使用下面的箭头浏览选项。",
	"noBattery": "这台电脑没有电池，仅可在接入电源的情况下使用。",
	"noCamera": "抱歉，这台电脑没有内置摄像头。",
	"noThunderbolt": "不，这台电脑未采用雷电技术。",
	"chatbotPopUp": "需要帮助？",
	"spftext": /但我不明白你的问题。/g,
	"rspftext": "但您要查找的信息不可用",
	"localeString": "zh-CN",
	"userName": "你",
	"fallbackCheck": "我不明白你的问题",
	"recognitionLocale": "zh",
	"resumeFlow": "恢复流程",
	"offlineScanText": "离线扫描",
	"feedbackq1":"您使用 Intelbot 服务的体验如何？",
	"one":"1",
	"two":"2",
	"three":"3",
	"four":"4",
	"five":"5",
	"veryPoor":"非常差",
	"poor":"差",
	"fair":"一般",
	"good":"好",
	"excellent":"出色",
	"feedbackq2":"请与我们分享您的反馈",
	"enter":"请在这里输入",
	"submitfb": "提交反馈",
	"feedbacktq1": "感谢您的宝贵反馈！",
	"feedbacktq2":" 如需更多帮助，请向我们发送电子邮件 - ",
	"feedbacktq3": "support@intel.com。",
	"likeordislike":"您的问题是否得到了解答？",
	"noresume":"此对话已恢复！请告诉我您还需要什么协助。",
	"offlineSRTmessage": "帮我找产品",
	"productRecommendation": "产品推荐",
	"stNotification": "会话超时通知",
	"touchscreenEnabled":"这款电脑配备触摸屏。像使用智能手机一样，以直观的控制方式与您的电脑交互，并享受更加锐丽、鲜活的细节。有关更多信息，请前往显示器详细信息页面。",
	"noTouchscreen":"这款电脑未配备触摸屏。有关更多信息，请前往显示器详细信息页面。",
	"agentTypingText":"顧問正在輸入",
	"applicationInfoService": [
		{
			"appName": "ibcn-1.3.0-design",
			"sourceName": "mfcn",
			"locale": "zh",
		}
	],
	"datalist" : [
        {
           "id": "1", 
            "agentTitle": "寻求更出色的性能？",
             "agentText": "第 13 代英特尔® 酷睿™ 处理器可帮助您在直播、创作和竞争时发挥出最高水平。"		
        },
        {
			"id": "2", 
            "agentTitle1": "需要更强大的多任务处理能力？",
             "agentText1": "利用第 13 代英特尔® 酷睿™ 处理器的高级多任务处理能力，立即提高工作效率，任何项目都不会影响您的速度。"
        },
        {
			"id": "3", 
            "agentTitle2": "是否可以进行更流畅的直播？",
             "agentText2": "英特尔® Wi-Fi 6E (Gig+) 的强大连接可带来极其流畅的直播体验。"
        },
		{
			"id": "4", 
            "agentTitle3": "希望提高创作水平？",
             "agentText3": "利用第 13 代英特尔® 酷睿™ 处理器的超强性能，您可以将超凡的创意变成现实。"
        },
		{
			"id": "5", 
            "agentTitle4": "想要提高工作效率？",
             "agentText4": "第 13 代英特尔® 酷睿™ 处理器性能超乎想象，助力电脑同时处理更多任务。"
        },
		{
			"id": "6", 
			 "agentTitle5": "寻求更出色的性能？",
			  "agentText5": "第 13 代英特尔® 酷睿™ 处理器可帮助您在直播、创作和竞争时发挥出最高水平。"		
		 },
		 {
			"id": "7", 
            "agentTitle6": "需要更强大的多任务处理能力？",
             "agentText6": "利用第 13 代英特尔® 酷睿™ 处理器的高级多任务处理能力，立即提高工作效率，任何项目都不会影响您的速度。"
        },
		{
			"id": "8", 
            "agentTitle7": "是否可以进行更流畅的直播？",
             "agentText7": "英特尔® Wi-Fi 6E (Gig+) 的强大连接可带来极其流畅的直播体验。"
        }
    
    ],
	"nsfwwords": "肛门的|肛门|阴交|多P|性交|肏|肏|口交|笨蛋|蠢货|混蛋|操你妈|浑蛋|操蛋|杂种|婊子|黑鬼|什么鬼|土人|阴茎|狗娘养的|狗日的|龟孙子|黑鬼|黑卵|废话|屄|约炮|该死的|该死|鸡巴|肮脏|衰人|蠢蛋|硬了|勃起|色情|三陪|搞基|基佬|滚蛋|操你妈|操蛋|操屄|该死|亚洲佬|赤裸裸的|爆操|同性色情|妓女|拉拉|女同性恋|婊子养的|日他妈的|操他妈的|黑鬼|老黑|嗨了|高潮|阴茎|基佬|尿|滚|A 片|三级片|色情片|阴道|傻逼|施虐狂|性交|性感|屎|荡妇|婊子养的|靠|乳头|伟哥|卖淫女|xxx|迷幻药|溶剂|迷幻蘑菇|酒精|甲基色胺|Amani|安非他命|亚硝酸酯|合成类固醇|湮灭|苄基哌嗪 (BZP)|烟草|苯并|Blast|吸水片|Bom|Bounce|Bud|大麻|卡西酮|Charley|Ching|卷烟|可卡因|可待因|古柯碱|快克|Crank|冰毒|D2PM|Depas|脱氧吡哆醇|Dezolam|二甲卡因|二甲基色胺|Dope|毒品|嗨|依替唑仑|Etisedan|依替唑仑|Etizolam|加巴喷丁|Gogaine|海洛因|Inxity|氯胺酮|LSD|Linctus|MDAT|摇头丸|霉酚酸|甲氧西明|大麻|Meph|甲氧麻黄酮|仙人掌毒碱|甲基苯丙胺|美沙酮|甲基苯丙胺|甲氧西明|甲基卡西酮|哌甲酯|Mozun|致幻剂|NPS|脑中柚皮素|NRG1|吡咯戊酮卡西酮|胭脂碱|Norries|奥巴马|鸦片剂|鸦片类药物|鸦片类|鸦片|4-甲氧基安非他命|强力摇头丸 (PMMA)|苯那西泮|苯环利定|Physeptone（美沙酮）|哌嗪|Poppers吸入剂|大麻|Quat|利他林|Roflcoptr|氟硝西泮|兴奋剂|迷幻药|鼠尾草|水烟|迷幻蘑菇|卷烟|安定|炸药|烟草|可卡因|嗑药|盐酸曲马多|安非他命|酒|安非他命|安非他命|死藤水|啤酒|安眠药|苄基哌嗪|酒精饮料|大麻粉|酒|丁烷|合成卡西酮|合成大麻素|大麻|卡西酮|可卡因|可待因|科尼亚克|快克|冰毒|毒品|右旋|安非他命|右旋安非他命|二乙酰吗啡|大麻|毒品|吸毒|嗑药|麻黄碱|哌乙酯|甲醛|大麻|金酒|哈希大麻|哈希什大麻|草药|海洛因|Hookah 水烟|氢可酮|甲基色胺|吸入剂|恺他命|致幻剂|大麻|摇头丸|甲氧麻黄酮|仙人掌毒碱|甲基安非他命|甲基苯丙胺|萘代哌甲酯|哌甲酯|吗啡|毒蘑菇|鸦片|迷幻药|poke|派醋丙酯|西洛西宾|吡咯戊酮|卡塔叶|qat|利他林|朗姆酒|skunk|烟|海洛因可卡因|成唑辛|烟草|壮阳药|维柯丁|伏特加|大麻叶|威士忌酒|whisky|威士忌|安非他命|葡萄酒|阿普唑仑|赛拉嗪|强奸犯|杀人犯|杀手|抢劫犯|犯罪分子|恐怖分子|刺客|施虐者|猥亵犯|罪犯|已绝育|绝育|种族灭绝|消灭|清洗|清理|消灭|残杀|残害|枪击|击中|刺|刺中|谋杀|被杀|大屠杀|暴打|被暴打|隔离|被隔离|种族隔离|被迫害|迫害|被起诉|起诉|奴隶|奴隶制|焚烧|烧毁|4r5e|5h1t|5hit|神|LBGT|a55|安拉|肛门的|肛门|ar5e|阿拉伯|阿拉伯人|arrse|笨蛋|蠢货|烂人|操你妈|操你妈逼|混蛋|混蛋|傻X|b!tch|b00bs|b17ch|b1tch|阴囊|卵|杂种|兽性|兽行|龟头|残暴|暴行|bi+ch|biatch|圣经|圣经|婊子|婊|臭婊子|婊里婊气|犯贱|贱人|流血|血腥|口交|口交|吹箫|同性恋|睾丸|蛋蛋|炸弹|硬了|乳房|奶子|大奶|大奶子|大咪咪|双峰|胸部|下身|佛教|鸡奸者|烂货|漂亮妞|屁股|屁眼|讨厌鬼|衰人|c0ck|c0cksucker|阴毛|屌|华裔|老中|基督|基督教|基督徒|逼|cl1t|clit|阴蒂|阴蒂|肛门|屌|混账|王八蛋|王八羔子|畜生|混蛋|欠揍|欠抽|龟孙子|龟儿子|兔崽子|死基佬|混蛋|烂货|烂人|混账|黑鬼|傻屌|废话|精液|鸡鸡|快射了|射精|射出精液|舔阴|阴交|口交|口爱|屄|舔阴|贱逼|舔逼|贱货|他达拉非|车震|约炮|车震|骗炮的|海王|约炮|d1ck|达依什|该死|烂人|龟儿子|假阳具|假阳具|蠢货|蠢蛋|傻蛋|dlck|打野战|野合|乡巴佬|蠢货|衰人|歹客|射精|射了|射|正在射精|多次射精|多P|射精|ejakulate|f4nny|搞基|搅基|基老|基佬|基友|死基佬|死同性恋|兔儿爷|死玻璃|阴道|阴唇|混蛋|屁股|死胖子|fcuk|fcuker|fcuking|肏|煞笔|吞精|口一下|口交|手活|白嫖|光看不买|只看不买|白嫖|手交|犯浑|被虐了|暴徒|大混蛋|虐待|大混蛋|拳交|阴部|干|狗东西|肏|混蛋|完蛋|流氓|混蛋|傻比|傻逼|尼玛|特么|我日|操你妈的逼|我操|我靠|二逼|二货|卧槽|基佬|我日|狗日的|狗日|天杀的|我操|呆逼|呆比|fux|fux0r|群批|多人行|群p|Gay|gay佬|gay|同性性爱|goatse 恶心图像|神啊|该死的|天杀的|神|福音|福音音乐|意大利乡巴佬|古拉格|古拉格劳改营|清真|硬核色情|恨|跨性别|异性恋|异性恋|异性恋者|印度教|希特勒|高级妓女|外围女|做鸡|大屠杀|同性恋|同性恋者|同性恋情|妓女|欲火焚身|性冲动|性感火辣|移民|移民者|移居|伊斯兰国|伊斯兰教|撸管|肏|肏|口交|jap|额滴神|白痴|耶稣|犹太人|犹太|精液|精子液体|精液|射精|老二|杀手|杀害|脱线|脑残|秀逗|缺根筋|弱智|基佬|搞基|鸡巴|避孕套|套套|犹太洁食|高潮|操蛋|快高潮了|达到高潮|口交|l3i+ch|l3itch|阴唇|蕾丝边|蕾丝|笑尿了|饥渴|m0f0|m0fo|m45terbate|ma5terb8|ma5terbate|mahoma|穆圣|受虐狂|主人|masterb8|masterbat*|masterbat3|手淫|自慰|自渎|打手枪|墨西哥人|mo|mof0|mofo|摩尔人|真他妈讨厌|真他娘烦|这他妈的一帮混蛋|这他娘的一帮混蛋|操你大爷的|草泥马|去你大爷的|滚你妈的蛋|杀千刀的|老不死的|短命的|母亲|他妈的|去你母亲的|操他妈的|你妈逼|妈的|奶奶的|大爷的|丫头养的|小丫挺的|阴部|谋杀|穆斯林的|穆斯林|妈妈|王八犊子|鳖孙|老母|干你老母|n1gga|n1gger|纳粹|纳粹|nigg3r|nigg4h|劣哥|黑人|黑哥们|黑鬼|老黑|老黑|把儿|傻屌|基佬|基佬|低能|智障|嗨了|高潮|高潮|性高潮|正教|p0rn|巴基斯坦佬|老巴|老巴子|炮灰|小鸡鸡|阴茎|基佬|电话性爱|靠|擦|玩完|我擦|我去|我草|擦|我艹|讨厌鬼|鸡巴|尿|气疯|废物|人渣|垃圾|阴唇|虐|干翻|滚犊子|拉屎|A 片|三级片|色情片|黄片|卑鄙的人|卑鄙之徒|pron|新教|新教徒|屌毛|阴户|私处|阴部|娘炮|娘炮|古兰经|可兰经|种族主义|种族主义分子|直肠|宗教|傻逼|rimjaw|舔肛|施虐狂|大老二|干|败家子|屌丝|阴囊|精子|sh!+|sh!t|sh1t|上|娘娘腔|做爱|上床|伪娘|shi+|神道|屎|败类|大便|完犊子|狗屎运|歇菜|萎了|乌龟王八蛋|拉屎|大便|排便|完犊子|屎缸|屎人|拉大便|窝屎|臭狗屎|人妖|女里女气|垃圾|荡妇|骚货|包皮垢|淫秽|肏|儿子|卑鄙小人|精浆|t1tt1e5|t1tties|塔木德经|奶头|奶子|恐怖主义|恐怖分子|睾丸|睾丸|咪咪头|乳房性交|乳头|奶头|tittie5|流氓|乳头|乳交|乳交|乳交|摩西五经|手淫者|跨性别者|变性人|变性者|三位一体|讨厌鬼|tw4t|娘们|煞笔|低能|卑劣|卑劣之人|v14gra|v1gra|阴道|伟哥|阴部|w00se|鸡鸡|撸管|二傻子|虚伪|站街女|小姐|心惊肉跳|成人影片|xxx|拜火教|民主党员|共和党|民主党|共和党|共产党|共产党员|共产主义|自由主义者|新保守主义|新保守主义者|新自由主义|新自由主义者|新自由主义|希拉里|政治家|政治|政治的|贪得无厌的|肯定的|法庭之友|上诉|任命|拨款|贵族|传讯|澳大利亚人|威权主义|AGBV|街区|资本主义|中央情报局|中部|民用|通用|共产主义|邦联的|联邦|宪法|同意|保守主义|合作的|法院|罪犯|民主|民主的|缓和|外交|法西斯主义|联邦|联邦制|联邦|政府|意识形态|倡议|法西斯主义|凯恩斯主义|经济学|立法|合法性|自由|自由主义|自由主义的|自由|有限|多数主义|货币|道德|自然|核|议会|党派关系|多元主义|政治文化|政治的|政治|政治家|热门|总统制|进步的|成比例的|批准|公投|回归的|代表|分裂|谢斯|补贴|选举权|霸权|神权政治|极权主义|单院|中央集权|民主党|共和党|政治|政治家|希拉里|斯坦|卡西|哈卡比|克林顿|特朗普|普京|鲍里斯|卡拉姆|阿塔尔|瓦杰帕伊|贝纳齐|阿文德|圣雄甘地|肯尼迪|拉鲁|亚达夫|纳伦德拉|迪斯雷利|丘吉尔|帕斯旺|乌彭德拉|库什瓦哈|玛雅瓦蒂|萨吉德|撒切尔|赛义达|男爵夫人|梅拉|巴克曼|阿尔塔夫|钱德拉|谢卡尔|扎克|高达|阿布尔|毛杜迪|西塔拉姆|阿吉特|伊恩|堕胎|亚伯拉罕|赦免|追随者|行动主义|阿丹|收养主义|基督降临节|非洲人|安拉|阿门|千禧年论|阿米什人|再洗礼派|类比学|祖先|天使学|英国国教|盎格鲁|阿尼米斯|歼灭主义|报喜|上古时代|国歌|人类学|拟人论|反浸信会|反基督|反邪教|反建制主义|反律法主义|安提奥尚|反三位一体论者|启示录|世界末日|启示录|伪经|道歉|道歉者|背道者|使徒|使徒的|使徒者|幻影|应用主义|大天使|大主教|大主教管区|执政官|阿罗汉|阿里亚尼斯|世界末日善恶决战|阿民念主义|雅利安人|扬升|提升|苦行者|阿舒拉节|阿什拉姆|假设|占星术|阿泰斯|无神论者|亚特兰蒂斯|赎罪|属性|自解说|艾亚姆|背罩|拜萨基|Baphome|浸信会|浸信会教徒|招致|引发|贝尔坦|博伽梵歌|圣经|圣经的|圣经教义|圣经崇拜|圣经学|主教|双神论者|黑人|亵渎神明|保佑|血|Blуt|菩提|菩萨|苯教|梵|婆罗门|洗脑|布赫曼主义|佛|佛教|秘密结社|哈里发|加尔文主义|封圣|红衣主教|教理问答|天主教|司祭|戒烟主义|脉轮|圣杯|通灵|领袖气质|千禧年主义|手相术|基督信仰|基督徒|基督论|楚帕|教会|割礼|圣餐|最近共同祖先|共同创造的|有条件的永生|保守|同质论|圣体共在论|沉思|处境化|归正|圣体|天体演化学|宇宙学|理事会|普世的|盟约|信条|十字中心主义|耶稣受难像|钉十字架|水晶|库尔|邪教|达赖|道教|达尔|达萨|执事|邪教|死亡|宗教|十诫|背道|神|神性|造物主|恶魔|恶魔的|道义论|绕圈仪式|堕落|解编程|魔鬼|法|侨民|迪亚特萨龙|二分法|十二使徒遣训|教区|硫绿岩|神性论|脱离|门徒|政教分离|反政教分离运动|除出教会|渐进主义者|解离|占卜|排灯节|教条主义|教义|教条|捐赠主义|末日|安息日|降格者|探测术|德鲁伊|二元论|双神论者|十胜节|伊便尼派|教会学|折衷主义|普世的|开斋节|解经学|大主教管区|求降圣灵文|求降圣灵文|圣公会|认识论|末世论|末世论的|密教|本质主义|伦理|符合伦理|圣餐|优生学|安乐死|福音书|福音派|传福音|提升|绝罚|解经学|驱魔|外来主义者|信仰|法齐赫|宿命论|裁决|女权主义|女权主义者|风|和子说|共济会制|自由思考者|奉献|原教旨主义者|教法（伊斯兰教）|欣嫩子谷|热尼扎|种族灭绝|异教徒|全球中心主义|风水术|少数民族聚居区|吉尔伽美什|方言|灵知|神|女神|福音|谒师所|《黑帝斯》|圣训|麦加朝圣|朝圣者|犹太教口传律法|清真|哈利路亚|万圣节|绑手礼|Harg|异教徒|天堂|恋童癖|希腊化|旧约圣经之前七卷|继承人|异端学家|异端学|赫雷蒂|诠释学|赫耳墨斯主义|异性恋主义|异性恋者|旧约六书|伊斯兰教妇女头巾|徙志|印度教|大屠杀|神圣|顺势疗法|恐同|天堂美女|伊斯兰神谕刑法|原质的|耶稣|拿撒勒人的耶稣|伊赫拉姆|先觉者|阿訇|洁净的|内在性|迫近|不道德|永生|无可挑剔|化身|梦魇|圣经无误论|无信仰者|初期|宗教裁判所|灵感|代祷|禁罚|禁令|跨信仰的|跨信仰主义|各宗教间的|圣餐面包浸酒|伊斯兰教叛教|伊斯兰教|伊斯兰教徒|伊斯兰主义|伊斯兰恐惧症|解经|天房|卡巴拉|欲乐|因果报应|神性放弃|犹太婚姻契约|伊斯兰教演讲|匼帕|匼帕|自然共通语|团契|古兰经|犹太洁食|克利须那神|剎那|耶稣基督后期圣徒教会|七十士译本|诵读|（礼拜用）《圣经》选文集|守法主义|利未人的|自由|解放|礼拜仪式|大人|路西法|路德主义|主流|念珠|曼荼罗|印度帐篷|摩尼教|显灵|曼特罗|马里亚主义者|阿拉伯清真寺|共济会|门诺派|弥赛亚|救世主的|变形力学|卫理公会派教徒|午夜|伊斯兰教堂壁龛|千禧年主义|宣礼塔|举行正式礼拜仪式的法定人数|神迹|弥撒书|沟通方式|Mohammed|脱离轮回|神格惟一论|隐修院|一元论|拜一神教|基督一性论者|单一性灵论|一神论|道德|道德观|清真寺| 多P|多元信仰|叛教|伊斯兰叛教|穆斯林|Mгra|招魂术|佛珠|新异教主义|新有神论|有神论|穆斯林婚姻|Nilhilis|涅槃|规范|数字命理学|一旦得救永恒得救|超自然的|Oleh|Olim|全知全能|全能|遍在|全知|合为一体|作品集|正教|和平主义|婴儿洗礼|印度教塔式寺庙|泛神论|泛神论者|万神殿|帕拉教堂|基督再临|孤雌发育|逾越节|易犯罪|幼儿洗礼|恋童癖|Pelagianis|苦修|五角星|五芒星|圣灵降临节|韧性|法利赛人|物理学|虔敬主义|灵物学|政治上|一妻多夫|一夫多妻|一夫多妻制|多神论|大吞噬|千禧年后论|祷告|预定论|长老宗|前设派|末世预言实现论|刻板主义|祭司|支持堕胎|支持自由选择|支持胎儿生命权|渎神的|进步的|预言|劝诱改宗|新教|协议|原始福音|讲道坛|炼狱|金字塔|种族主义|斋月|被提|飞天面条神教|飞面神教信徒|拉斯塔法里教|理性主义|重生|审查删减|巫术规章|救赎|反射疗法|宗教改革|改教后的|重生|宗教|信仰|有信仰的|宗教主义|复原主义|倒退|Rhem|正义|仪式|玫瑰经|例行化|罗素的圣经学生|安息日|安息日教|安息日|撒伯流主义|圣礼|萨达卡|撒都该人|圣伴|圣人|叩头章|伊斯兰教礼拜|救世|救世的|三摩地/定|萨温节|轮回|神圣化|犹太公会|圣者之道|撒旦|撒旦崇拜的|撒旦|替罪羊|教派分裂|经文|降神会|世俗的|世俗化|永恒的|逾越节家宴|细拉|七十士译本|蛇|服务|性歧视|伊斯兰教法|色旦|羔羊|示玛祷告|牧养|什叶|神道|大屠杀|闪避|锡克教|五蕴|所多玛人|至日|术士|救赎论|唯灵论|精神主义|灵性|卍纹|卍|刻板印象|圣痕|下意识|物质|魅魔|副主教|苏菲主义|逊尼派|苏拉|契经|卍纹|犹太会堂|折衷论|协同效应|教会会议|系统的|塔利特|塔木德经|希伯来圣经|道教|目的论的|圣殿|恐怖主义|四元组|四字神名|经文的|有神论者|神权政治|神学|神学|显灵|成神论|神化|成神论|参与|疗愈的|彻夜诵读|什一税|时论主义|传统的|传统|传统主义|超越|变容|转生|圣餐变体论|灾难|三分律|三位一体|三位一体的|三神论|无信仰|无条件|未识别|位格合一|一位论的|普遍主义|天人合一|不可宽恕|奥义书|犹太教理发仪式|伊斯兰教原理|吠陀|小|处女|毗湿奴|巫毒教|自愿主义|巫毒|圣经拉丁通俗译本|圣沃普尔吉斯之夜|巫师|守望台圣经书社|西敏寺|威卡教|威卡教徒|逆时针旋转|女巫|巫术|妇女主义|妇女主义者|Womym|崇拜|木头崇拜|雅威（耶和华）|亚莫克帽|耶鲁节|奋锐党|反政教分离思想|无信仰者|仪式|巴哈伊信仰|巴哈欧拉|克苏鲁|shub|奈亚拉托提普|犹格·索托斯|snowflake|雪花|绿帽|绿帽人士|绿帽保守派|低等男|低等的男性|低等男性|蓝色药丸|BTFO|烂到家了|自由派蠢货|倒退的|社会正义|tumblrina|woke|MAGA|让美国再次强大|喷子|直男癌|机器人|俄罗斯水军|喷子工厂|香烟|法西斯主义者|随波逐流之人|多边恋|皮条客|皮条客|拉皮条|避孕套|安全套"
}
